import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import {Link} from 'react-router-dom';
import {IconEye,IconEyeLock, ArrowRight, IconLock, IconLockEye} from '../../assets/icons/svgIcon';
import {SvgAssets} from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import { activarAcceso } from '../../store/sagas/authApi';
import { notificacion } from '../../utilitarios/util';
import Spinner from "../reusable/Loader";

function SendEmail ({ dadComponent }){
  const { loading, password1, password2, errorValidacion, hidePassword1, icon1, hidePassword2, icon2 } = dadComponent.state;

  return(
    <div>
      <h4 className="text-center title-2 naranja desktop"><SvgAssets className="mr-2" icon="icon-lock" fill={c.naranja}/>Nueva contraseña</h4>
      <div className="card card_container">
        <h4 className="text-center title-2 mobile naranja"><SvgAssets icon="icon-lock" className='icon-block' fill={c.naranja} />Nueva <br/> contraseña</h4>
        <form>
          <FormGroup className="icon">
            <Input className="naranja" type={!hidePassword1? 'text' : 'password'} name="password" placeholder="Contraseña" onChange={(e) => {let password1 = e.currentTarget.value; dadComponent.setPassword1(password1)}} />
            <Button color="link" className="btn-icon naranja" onClick={() => dadComponent.changeIcon1()}>
              {!hidePassword1 ? <IconEye/> : <IconEyeLock/>}
            </Button>
          </FormGroup>
          <FormGroup className="icon">
            <Input className="naranja" type={!hidePassword2? 'text' : 'password'} name="password" placeholder="Confirmar contraseña" onChange={(e) => { let password2 = e.currentTarget.value; dadComponent.setPassword2(password2)}} />
            <Button color="link" className="btn-icon naranja" onClick={() => dadComponent.changeIcon2()}>
              {!hidePassword2 ? <IconEye/> : <IconEyeLock/>}
            </Button>
            {errorValidacion ? <FormFeedback>{errorValidacion}</FormFeedback> : null}
          </FormGroup>
          <p className="paragraph-2 desktop_parrafo3" style={{ color: c.naranja }}>Debe contener al menos una letra mayúscula, una minúscula, un número y un símbolo. Mínimo 6 y máximo 20 caracteres.</p>
        </form>
        <div className="text-center mt-5 mobile">
          <button
            type="button"
            className={`btn-block red${(password1 != "" && password2 != "" ? "" : " disabled")}`}
            disabled={password1 == "" || password2 == ""}
            onClick={() => dadComponent.ActivarAcceso()}>
            siguiente<ArrowRight className='svg-right' />
          </button>
        </div>
      </div>
      <div className="text-center mt-5 desktop">
        <button
          type="button"
          className={`btn-block red${(password1 != "" && password2 != "" ? "" : " disabled")}`}
          onClick={() => dadComponent.ActivarAcceso()}>
          siguiente<ArrowRight className='svg-right' />
        </button>
      </div>
    </div>
  )
}

function Message ({ dadComponent }){
  const { } = dadComponent.state;
  return(
    <div>
      <h4 className="text-center title-2 desktop verde"><SvgAssets className="mr-2" icon="icon-eye" fill={c.verdeClaro}/>Contraseña actualizada</h4>
      <div className="card card_container">
        <h4 className="text-center title-2 mobile verde"><SvgAssets icon="icon-eye" className='icon-block' fill={c.verdeClaro}/>Contraseña <br/> actualizada</h4>
        <p className="paragraph-1 text-center mb-text verde light">Tu contraseña ha sido actualizada. <strong>Sigue disfrutando de la experiencia Asiri.</strong></p>
        <div className="text-center mt-5">
          <Link to={{pathname: '/', state: { step: 1 }}} style={{textDecoration:'none'}}>
            <button className='btn-block red'>iniciar sesión</button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export class NuevaContrasenia extends Component {
  static displayName = NuevaContrasenia.name;

  constructor (props) {
    super(props);

    this.state = {
      step: 0,
      email: null,
      codigoVerificacion: null,
      password1: '',
      loading: false,
      password2: '',
      errorValidacion: null,
      hidePassword1: true,
      hidePassword2: true,
      icon1: 'icon-eye-close',
      icon2: 'icon-eye-close',
    };
  }

  nextStep() {
    this.setState({step: this.state.step + 1})
  }

  backStep() {
    this.setState({step: this.state.step - 1})
  }

  togglePassword1() {
    this.setState({password1: !this.state.password1})
  }
  togglePassword2() {
    this.setState({password2: !this.state.password2})
  }
  changeIcon1() {
    this.setState(prevState => ({
      icon1: prevState.icon1 == 'icon-eye' ? 'icon-eye-close' : 'icon-eye',
      hidePassword1: !prevState.hidePassword1
    }))
  }
  changeIcon2() {
    this.setState(prevState => ({
      icon2: prevState.icon2 == 'icon-eye' ? 'icon-eye-close' : 'icon-eye',
      hidePassword2: !prevState.hidePassword2
    }))
  }
  ActivarAcceso = () => {
    this.setState({ errorValidacion: null, loading: true });
    if (this.state.password1 == null || this.state.password1 == "" || this.state.password2 == null || this.state.password2 == "") {
      this.setState({ errorValidacion: "Debe ingresar el password", loading: false });
    } else if ((/^$|\s+/.test(this.state.password1))) {
      this.setState({ errorValidacion: "No debe tener espacios vacíos", loading: false });
    } else if (this.state.password1.length < 6 || this.state.password1.length > 20) {
      this.setState({ errorValidacion: "Debe ingresar entre 6 a 20 caracteres", loading: false });
    } else if (!(/[A-ZÑ]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe tener al menos una letra mayúscula", loading: false });
    } else if (!(/[a-zñ]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe tener al menos una letra minúscula", loading: false });
    } else if (!(/[0-9]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe contener al menos un número", loading: false });
    } else if (!(/[+×÷=/_€£()!¡¿*&^%$#@\\""':;,?.`~|<>°•○●□■♤♡◇♧₩¥¤▪︎☆》《-]/.test(this.state.password1))) {
      this.setState({ errorValidacion: "Debe tener al menos un símbolo", loading: false });
    } else if (this.state.password1 != this.state.password2) {
      this.setState({ errorValidacion: "Debe ingresar el mismo password", loading: false });
    } else {
      this.postActivarAcceso();
    }
  }
  postActivarAcceso = async () => {
    let CorreoElectronico = this.state.email;
    let CodigoVerificacion = this.state.codigoVerificacion;

    let Contrasenia = this.state.password1;
    this.setState({ loading: true });
    activarAcceso(CorreoElectronico, Contrasenia, CodigoVerificacion)
      .then(result => {
        this.setState({ loading: false });
        if (result.mo.type == "success") {
          this.setState({ loading: false }, async () => {
            this.nextStep();
            // this.props.navigation.navigate('ContraseniaActualizada');
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        //console.log("postLogin ", error);
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });
  }
  setPassword1 = (value) => {
    this.setState({ password1: value, errorValidacion: null })
  }
  setPassword2 = (value) => {
    this.setState({ password2: value, errorValidacion: null })
  }
  checkParams() {
    const { state } = this.props.location;
    this.setState({ email: state.email, codigoVerificacion: state.codigoVerificacion });
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  renderStep() {
    switch(this.state.step) {
      case 0:
        return <SendEmail dadComponent={this} />
      case 1:
        return <Message dadComponent={this} />
      default:
        return <SendEmail dadComponent={this} />
    }
  }

  render () {
    const { loading } = this.state;
    return (
      <Container className="py-5" id="mhw">
        <Spinner visible={loading} />
        {this.renderStep()}
      </Container>
    );
  }
}
